import * as React from 'react'
import { FormValue, FileTextValue } from '../../reducers/form-values'
import { blurHandlerFn, inputValueChangeFn } from './form-type-selector'
import { nl2br, targetBlankifyLinks } from '../utils'
import { errorMsg } from './build-error-msg'

type Props = {
  data
  value: FileTextValue
  inputValueChange: inputValueChangeFn
  blurHandler: blurHandlerFn
}

type State = {
}

class TextArea extends React.Component<Props, State> {
  inputRef = React.createRef<HTMLTextAreaElement>()

  componentDidMount () {
    this.inputRef.current.value = this.props.value.value
  }

  onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { selectionStart, selectionEnd } = e.target
    this.props.inputValueChange(this.props.data.qid, 'textInput', e.target.value)
    e.target.setSelectionRange(selectionStart, selectionEnd)
  }

  onBlur = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    this.props.blurHandler(this.props.data.qid)
  }

  render () {
    const labelHtml = {
      __html: nl2br(targetBlankifyLinks(this.props.data.label))
    }

    return (
      <div className={this.props.data.className ? this.props.data.className : 'col-xs-12'} key={this.props.data.qid}><div
      className={'input-line input-textfield'}>
        {this.props.data.label &&
        <label
          htmlFor={this.props.data.qid}>
          <span dangerouslySetInnerHTML={labelHtml}></span>
           <span className='fieldRequired'>{this.props.data.required && '*'}</span>
        </label>}
        <textarea
          ref={this.inputRef}
          id={this.props.data.qid}
          name={this.props.data.qid}
          className='form-control'
          cols={42}
          rows={this.props.data.rows}
          placeholder={this.props.data.placeholder}
          onChange={this.onChange}
          onBlur={this.onBlur}
          aria-required={this.props.data.required}
          aria-invalid={!!this.props.data.errorMessage}
          ></textarea>
        {this.props.data.errorMessage &&
          errorMsg(this.props.data.qid, this.props.data.errorMessage)}
      </div></div>
    )
  }
}

export function buildTextarea (
  data,
  value: FileTextValue,
  inputValueChange: inputValueChangeFn,
  blurHandler: blurHandlerFn): JSX.Element {
  return <TextArea
    key={data.qid}
    data={data}
    value={value}
    inputValueChange={inputValueChange}
    blurHandler={blurHandler}
    />
}
